import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TableConfig } from '@app/shared/components/table/table.component';
import { FilterType } from '@app/shared/enums/filter.enums';
import { FilterBarConfig, FilterValues } from '@app/shared/interfaces/filter.interfaces';
import { TableColumn } from '@app/shared/interfaces/table-column.interfaces';
import { teamSelectors } from '@app/team/state/team.state';
import { BusinessUnit } from '@entities/business-unit';
import { Department } from '@entities/department';
import { DepartmentFunction } from '@entities/department-function';
import { TeamMember } from '@entities/team-member';
import { Store } from '@ngrx/store';
import { BehaviorSubject, of } from 'rxjs';

interface LeadershipAssignment {
   role: string;
   businessUnit?: BusinessUnit;
   department?: Department;
   departmentFunction?: DepartmentFunction;
   index: number;
}

@Component({
   selector: 'app-leadership-assignments',
   templateUrl: './leadership-assignments.component.html',
   styleUrls: ['./leadership-assignments.component.scss'],
})
export class LeadershipAssignmentsComponent {
   store = inject(Store);
   //  router = inject(Router);

   dataSource$ = this.store.select(teamSelectors.getLeadershipAssignments);
   filter$ = new BehaviorSubject<FilterValues>({});
   visibleColumns$ = of([]);

   columns: TableColumn<LeadershipAssignment>[] = [
      {
         def: 'index',
         label: '',
         value: (row) => '',
         filterValue: (row) => row.index,
         visible: true,
      },
      {
         def: 'role',
         label: 'Role',
         value: (row) => row.role,
         visible: true,
      },
      {
         def: 'businessUnit',
         label: 'Business Unit',
         value: (row) => row.businessUnit?.name,
         visible: true,
         filter: FilterType.BusinessUnit,
      },
      {
         def: 'department',
         label: 'Department',
         value: (row) => row.department?.name,
         visible: true,
         filter: FilterType.Department,
      },
      {
         def: 'departmentFunction',
         label: 'Function',
         value: (row) => row.departmentFunction?.name,
         visible: true,
         filter: FilterType.DepartmentFunction,
      },
   ];
   tableConfig: TableConfig;

   filterConfig: FilterBarConfig = {
      businessUnits: true,
      departments: true,
      departmentFunctions: true,
      hideEditColumns: true,
      filterChange: (filterValues) => this.updateFilter(filterValues),
   };

   ngOnInit() {
      this.tableConfig = {
         data$: this.dataSource$,
         filter$: this.filter$,
         columns: this.columns,
         visibleColumns$: this.visibleColumns$,
         initialSort: { active: 'index', direction: 'asc' },
         options: [
            // { label: 'Details', action: (row) => this.goToEntity(row) }
         ],
         rowClick: () => undefined,
      };
   }

   goToEntity(entity: LeadershipAssignment) {}

   updateFilter(filterValues: FilterValues) {
      this.filter$.next(filterValues);
   }
}

